import React from 'react';
import loadable from '@loadable/component';

import { Route, Routes, BrowserRouter } from 'react-router-dom';
import IoTSolutions from './components/Pages/IoTSolutions';
import Controlers from './components/Pages/Controllers/Controlers';
import Simulator from './components/Pages/Simulator/Simulator';
import RealEstate from './components/Pages/RealEstate';
import CPOs from './components/Pages/CPOs';
import Fleet from './components/Pages/Fleet';
import HomeCharger from './components/Pages/HomeCharger';
import ProductLaunch from './components/Pages/ProductLaunch';
import MiniDCChargerPage from './components/Pages/MiniDCChargerPage'; 
import CareersLanding from './components/Pages/Careers/CareersLanding';
import CareersOpenings from './components/Pages/Careers/CareersOpenings';
import CareerDetails  from './components/Pages/Careers/CareerDetails';
import AcDevlopmentKit from './components/Pages/AcDevKitCommercial'
import AcDevKitSkill from './components/Pages/AcDevKitSkill';
import LevDC from './components/Pages/LevDc';
// import EvSimlator from './components/Pages/EvSimulator'
// import Services from './components/Pages/OurServices';

 
 


const Footer = loadable(() => import('./components/Molecules/Footer'));
const GiftCityFooter = loadable(() => import('./components/Molecules/Footer/giftcityfooter'));

const Navbar = loadable(() => import('./components/Molecules/Navbar'));
const Homepage = loadable(() => import('./components/Pages/Homepage'));
const Contact = loadable(() => import('./components/Pages/ContactUs'));
const About = loadable(() => import('./components/Pages/AboutUs'));
const Business = loadable(() => import('./components/Pages/Business'));
const ProductsLanding = loadable(() => import('./components/Pages/ProductsLanding'));
const ComingSoon = loadable(() => import('./components/Pages/ComingSoon'));
const MobileApp = loadable(() => import('./components/Pages/MobileApp'));
const Error404 = loadable(() => import('./components/Pages/Error404'));
const FAQ = loadable(() => import('./components/Pages/Faq'));
const CMS = loadable(() => import('./components/Pages/CMS'));
const BecomeDistributor = loadable(() => import('./components/Pages/BecomeDistributor'));
const HostCharger = loadable(() => import('./components/Pages/hostCharger'));
const GiftCity = loadable(() => import('./components/Pages/Pr-giftCity-temp'));
const FleetCampaign = loadable (() => import('./components/Pages/FleetCampaign'));
const ProductLaunchFooter = loadable(() => import('./components/Molecules/Footer/productlaunchfooter'));

const ProductLaunchNavbar = loadable(() => import('./components/Molecules/Navbar/ProductLaunchNavbar'));



const ViewWithNavbar = ({ children }) => {
  return (
    <>
      <Navbar />
      <div className="min-h-screen">{children}</div>
      <Footer />
    </>
  );
};

const ViewFooterOnly = ({ children }) => {
  return (
    <>
      
      <div className="min-h-screen">{children}</div>
      <Footer />
    </>
  );
};

const ViewWithoutDealership = ({ children }) => {
  return (
    <>
      <Navbar />
      <div className="min-h-screen">{children}</div>
      <GiftCityFooter />
    </>
  );
};

const ViewSimpleHeaderFooter = ({ children }) => {
  return (
    <>
      <ProductLaunchNavbar />  {/* ✅ Custom header only for /product-launch */}
      <div className="min-h-screen">{children}</div>
      <ProductLaunchFooter />
    </>
  );
};
 


function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={<ViewWithNavbar children={<Homepage />} />}
          />
          <Route
            path="/get-in-touch"
            element={<ViewWithNavbar children={<Contact />} />}
          />
          <Route
            path="/about"
            element={<ViewWithNavbar children={<About />} />}
          />
          <Route
            path="/business"
            element={<ViewWithNavbar children={<Business />} />}
          />
          <Route
            path="/hardware"
            element={<ViewWithNavbar children={<ProductsLanding />} />}
          />
          <Route path="/cms" element={<ViewWithNavbar children={<CMS />} />} />
          <Route
            path="/mobile-app"
            element={<ViewWithNavbar children={<MobileApp />} />}
          />
          <Route
            path="/partner-with-us"
            element={<ViewWithNavbar children={<BecomeDistributor />} />}
          />
          <Route
            path="/fleet"
            element={<ViewWithNavbar children={<Fleet />} />}
          />
          <Route
            path="/host-charger"
            element={<ViewWithNavbar children={<HostCharger />} />}
          />
          <Route
            path="/pr-giftcity"
            element={<ViewWithoutDealership children={<GiftCity />} />}
          />

          <Route path="/faq" element={<ViewWithNavbar children={<FAQ />} />} />

          <Route
            path="/mobility-solution"
            element={<ViewWithNavbar children={<IoTSolutions />} />}
          />

          <Route
            path="/controllers"
            element={<ViewWithNavbar children={<Controlers />} />}
          />

          <Route
            path="/real-estate"
            element={<ViewWithNavbar children={<RealEstate />} />}
          />

          <Route
            path="/cpos"
            element={<ViewWithNavbar children={<CPOs />} />}
          />

          <Route
            path="/home-charger"
            element={<ViewWithNavbar children={<HomeCharger />} />}
          />

          <Route
            path="/fleet-calculator"
            element={<ViewWithNavbar children={<FleetCampaign />} />}
          />

          <Route
            path="/coming-soon"
            element={<ViewWithNavbar children={<ComingSoon />} />}
          />

          <Route
            path="*"
            element={<ViewWithNavbar children={<Error404 />} />}
          />
          {/* <Route
            path="/product-launch"
            element={<ViewSimpleHeaderFooter children={<ProductLaunch />} />}
          /> */}
          <Route
            path="/mini-dc-charger"
            element={<ViewFooterOnly children={<MiniDCChargerPage />} />}
          />

          <Route
            path="/careers"
            element={<ViewWithNavbar children={<CareersLanding />} />}
          />
          <Route
            path="/careers/openings"
            element={<ViewWithNavbar children={<CareersOpenings />} />}
          />
          <Route
            path="/careers/:slug"
            element={<ViewWithNavbar children={<CareerDetails />} />}
          />

          <Route
            path="/acdevelopmentkit"
            element={<ViewWithNavbar children={<AcDevlopmentKit />} />}
          />
           <Route
            path="/acdevkitskill"
            element={<ViewWithNavbar children={<AcDevKitSkill />} />}
          />
          <Route
            path="/levdc"
            element={<ViewWithNavbar children={<LevDC />} />}
          />
          {/* <Route
            path="/evsimulator"
            element={<ViewWithNavbar children={<EvSimlator />} />}
          /> */}

            {/* <Route
            path="/services"
            element={<ViewWithNavbar children={<Services />} />}
          /> */}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
